module.exports = __webpack_public_path__ + "static/media/del-sol.f8f5031c.svg";